<template>
  <div>
    <div class="d-flex align-items-center">
      <div class="side-frame"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          TemplateNo：{{ formData.templateNo || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Create：{{ formData.createByName || '--' }} at
          {{ formData.createTime || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      size="mini"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :span="18">
          <el-row :gutter="20">
            <el-col :span="5">
              <el-form-item
                :label="$l('form_label_templateGroup') || '模版组'"
                prop="templateGroup"
              >
                <dict-select
                  v-model="formData.templateGroup"
                  url="/sys/common/dict/system"
                  style="width:100%"
                  size="mini"
                  clearable
                  filterable
                  :disabled="disabled"
                  :body="templateGroupParams"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                >
                </dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item
                :label="$l('form_label_templateType') || '模板类型'"
                prop="templateType"
              >
                <el-select
                  v-model="formData.templateType"
                  style="width:100%"
                  size="mini"
                  clearable
                  filterable
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                >
                  <el-option value="import" label="导入(import)" />
                  <el-option value="export" label="导出(export)" />
                  <el-option value="print" label="打印(print)" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item
                :label="$l('form_label_templateName') || '模板名称'"
                prop="templateName"
              >
                <el-input
                  clearable
                  v-model="formData.templateName"
                  :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                  maxlength="200"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_templateDesc') || '模板描述'"
                prop="templateDesc"
              >
                <el-input
                  clearable
                  v-model="formData.templateDesc"
                  :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                  maxlength="500"
                  type="textarea"
                  show-word-limit
                  :autosize="{ minRows: 2 }"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-upload
                action="/oss/ossUploadReturnUrlAndFileId"
                :file-list="templateFile"
                :auto-upload="false"
                :on-change="onFileChange"
                :on-remove="onFileChange"
              >
                <el-button slot="trigger" size="small" type="primary">
                  {{ $l('INDEX.order_form_btn_select_file') || '选取文件' }}
                </el-button>

                <div slot="file" slot-scope="{ file }">
                  <a
                    style="text-decoration: none;margin-right:50px"
                    class="el-upload-list__item-name"
                  >
                    <i class="el-icon-document"></i>
                    {{ file.name }}
                  </a>
                  <i
                    class="el-icon-folder-opened mr-4"
                    @click="onFilePreview(file)"
                  ></i>
                  <i
                    class="el-icon-close"
                    v-if="!disabled"
                    @click="onFileDelete()"
                  ></i>
                </div>
              </el-upload>
            </el-col>
          </el-row>
        </el-col>
        <!-- required -->
        <el-col :span="6">
          <el-form-item
            :label="
              $l('form_label_upload_preview_thumbnail') || '上传预览缩略图'
            "
            required
          >
            <br />
            <UploadThumbnail
              :templateThumbnailUrl.sync="formData.templateThumbnailUrl"
              @updateThumbnail="updateThumbnail"
              :disabled="disabled"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider style="margin :10px 0"></el-divider>
      <el-row :gutter="20">
        <el-col :span="24">
          <TemplateAttachment
            ref="templateAttachment"
            :templateAttachmentList="templateAttachmentList"
            :disabled="disabled"
            :multipleDisabled="true"
          />
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import UploadThumbnail from '../uploadThumbnail'
import TemplateAttachment from './templateAttachment'

export default {
  mixins: [EditLoading],
  components: {
    UploadThumbnail,
    TemplateAttachment,
  },
  props: {
    disabled: { type: Boolean, default: false },
    templateCode: { type: String, default: '' },
  },
  data() {
    return {
      templateGroupParams: { dictType: 'templateGroup' },
      backDialogVisible: false,
      templateFile: [],
      templateAttachmentList: [],
      data: {},
      formData: {
        templateThumbnailUrl: '',
      },
      rules: {
        templateGroup: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        templateType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        templateName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        templateDesc: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.templateCode) return
      this.$api
        .sysInoutTemplateDetailApi({
          templateCode: this.templateCode,
        })
        .then((res) => {
          this.formData = res.body
          this.templateAttachmentList = res.body.templateAttachmentList
          const { templateFileName, templateFileUrl } = res.body
          this.templateFile = [{ name: templateFileName, url: templateFileUrl }]
        })
    },
    async submitSave() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      if (
        !(
          this.formData.templateThumbnailCode &&
          this.formData.templateThumbnailUrl
        )
      ) {
        this.$message.warning(
          this.$l('tips_please_add_thumbnail') || '请添加缩略图'
        )
        return
      }

      if (!(this.formData.templateFileCode && this.formData.templateFileName)) {
        this.$message.warning(
          this.$l('tips_please_add_template_file') || '请添加模板文件'
        )
        return
      }

      const templateAttachmentList = await this.$refs.templateAttachment
        .getTableData()
        .then((res) => {
          if (!res) return false
          return res.tableData
        })
      if ('boolean' === typeof templateAttachmentList) return
      this.formData.templateAttachmentList = templateAttachmentList
      this.loadingOpen()
      return this.$api
        .sysInoutTemplateSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.$emit('close')
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },

    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    onFileChange(files, fileList) {
      // 验证文件数量，替换后仅保留第一个文件
      if (fileList.length > 1) {
        const isLt10M = fileList[1].size / 1024 / 1024 < 10
        if (!isLt10M) {
          this.$message.error(
            this.$l('tips_upload_file_size_cannot_exceed_10MB') ||
              '上传文件大小不能超过 10MB!'
          )
          fileList.splice(1, 1)
          return
        }
        fileList.splice(0, 1)
      }
      this.templateFile = fileList
      if (this.templateFile && this.templateFile.length > 0) {
        this.uploadTemplateFile(this.templateFile[0])
        return
      }
      this.formData.templateFileCode = ''
      this.formData.templateFileName = ''
    },

    uploadTemplateFile(value) {
      this.$api
        .SYS_UPLOAD(value.raw)
        .then((res) => {
          this.formData.templateFileCode = res.body.fileId
          this.formData.templateFileUrl = res.body.url
          this.formData.templateFileType = value.name.substring(
            value.name.lastIndexOf('.') + 1
          )
          this.formData.templateFileName = value.raw.name
        })
        .catch(() => null)
    },
    updateThumbnail(value) {
      this.formData.templateThumbnailCode = value.templateThumbnailCode
        ? value.templateThumbnailCode
        : ''
      this.formData.templateThumbnailUrl = value.templateThumbnailUrl
        ? value.templateThumbnailUrl
        : ''
    },
    onFilePreview(file) {
      let url = ''
      if (file.raw) url = URL.createObjectURL(file.raw)
      if (file.url) url = file.url
      window.open(url)
    },
    onFileDelete() {
      this.templateFile = []
      this.formData.templateFileCode = ''
      this.formData.templateFileName = ''
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .input-with-select .el-select .el-input {
  width: 220px;
}
::v-deep .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.side-frame,
.side-frame-success,
.side-frame-danger,
.side-frame-warning {
  padding: 1px 5px;
  height: 20px;
  margin: 8px 0;
}
a:hover {
  color: #409eff;
  text-decoration: none;
}

.el-upload-list__item .el-icon-folder-opened {
  display: none;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  opacity: 0.75;
  color: #606266;
}

.el-upload-list__item:hover {
  .el-icon-folder-opened {
    display: inline-block;
  }
}
::v-deep {
  .el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 10px 0;
  }
}
</style>
